export const AUTOSAVE_INTERVAL = 5000;
export const AUTOSAVE_TIMEOUT = 120000;
export const VERSION = '${version}';
// user idle timeout in minutes
export const USER_IDLE = 15;
export const SEARCH_PAGE_SIZE = 20;
